module.exports = __webpack_public_path__ + "img/main1.214ddc10.png";